import React from 'react'
import styled from 'styled-components'
import { Pagination } from 'antd'
import { Spacer } from './Spacer'
import { text } from '../styles/mixins/text'

type Props = {
    currentPage: number
    totalItems: number
    pageSize: number
    className?: string
    children: JSX.Element[] | JSX.Element
    disabled?: boolean
    onPageSelect: (nextPageIndex: number) => void
}

export const PaginationContainer = (props: Props): JSX.Element => {
    const { children, className, pageSize, currentPage, totalItems, onPageSelect, disabled } = props

    const currentIdx = pageSize * currentPage
    let lastIdx = currentIdx + pageSize
    if (lastIdx > totalItems) lastIdx = totalItems
    return (
        <Container className={className}>
            {children}
            <Spacer vertical size={2} />
            <Footer>
                <Count>{`${currentIdx + 1}-${lastIdx} of ${totalItems} items`}</Count>
                <Pagination
                    simple
                    disabled={disabled}
                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
                    defaultCurrent={1}
                    current={currentPage + 1}
                    pageSize={pageSize}
                    onChange={(pageNumber) => onPageSelect(pageNumber - 1)}
                    total={totalItems}
                />
            </Footer>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    min-height: 0px;
    min-width: 0px;
`

const Footer = styled.div`
    display: flex;
    flex-flow: row nowrap;
    flex: 0 0 auto;
    min-width: 0px;
    justify-content: space-between;
    .ant-pagination-simple {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;
        ${text('label')}
    }
    .ant-pagination-total-text {
        margin-right: auto;
        ${text('label')}
    }
    .ant-pagination-simple-pager input {
        width: 50px;
        ${text('label')}
    }
    .ant-pagination-simple-pager {
        ${text('label')}
    }
`

const Count = styled.span`
    white-space: nowrap;
    ${text('label')}
`
